import { useEffect, useState } from "react";
import { Link, useOutletContext } from "react-router-dom";
import api, { fmtNZD, fmtDate } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

function UnlockInfo({ b }) {
  if (!b.unlock) return null;
  const active = !b.locked;
  return <div className="text-[11px] text-amber-300" data-testid={`pb-unlock-info-${b.id}`}>{active ? "Unlocked" : "Last unlocked"} by {b.unlock.by} · {fmtDate(b.unlock.at)} · "{b.unlock.reason}"</div>;
}

export default function ProjectBills() {
  const { project } = useOutletContext();
  const { user } = useAuth();
  const [bills, setBills] = useState([]);
  const [err, setErr] = useState("");

  async function load() {
    const { data } = await api.get("/bills", { params: { project_id: project.id } });
    setBills(data);
  }
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [project.id]);

  async function unlock(b) {
    const reason = window.prompt("Reason for unlocking this bill (required):");
    if (reason === null) return;
    try { setErr(""); await api.post(`/bills/${b.id}/unlock`, { reason }); load(); }
    catch (e) { setErr(e?.response?.data?.detail || "Couldn't unlock"); }
  }

  const total = bills.reduce((s, b) => s + (parseFloat(b.total) || 0), 0);
  return (
    <div className="space-y-3" data-testid="project-bills">
      <div className="card flex gap-2 items-center justify-between flex-wrap">
        <div className="text-sm">{bills.length} bill(s) · <b data-testid="pb-total">{fmtNZD(total)}</b> ex GST
          {project.status === "Complete" || project.status === "Archived" ? <span className="ml-2 text-amber-300" data-testid="pb-locked-note">Project is {project.status}: bills are locked.</span> : null}
        </div>
        <Link to="/operations/bills" className="btn-ghost text-sm" data-testid="pb-manage">Bills inbox →</Link>
      </div>
      {err && <div className="text-red-400 text-sm" data-testid="pb-error">{err}</div>}
      <div className="card overflow-x-auto">
        <table className="table">
          <thead><tr><th>Date</th><th>Supplier</th><th>Number</th><th>Category</th><th>Amount</th><th>Status</th><th>Xero</th><th></th></tr></thead>
          <tbody>{bills.map(b => (
            <tr key={b.id} data-testid={`pb-row-${b.id}`}>
              <td>{fmtDate(b.issue_date) || "—"}</td>
              <td>{b.supplier || "—"}<UnlockInfo b={b} /></td>
              <td>{b.number || "—"}</td>
              <td>{b.category || "Materials"}</td>
              <td>{fmtNZD(b.total)}</td>
              <td><span className="badge badge-grey">{b.status}</span>{b.locked && <span className="ml-1 text-[11px] opacity-70" data-testid={`pb-locked-${b.id}`}>Locked</span>}</td>
              <td className="text-xs">{b.sent_to_xero_at ? `Sent ${fmtDate(b.sent_to_xero_at)}` : "—"}</td>
              <td>{b.locked && user?.role === "Admin" && (project.status === "Complete" || b.reported_at) && (
                <button type="button" className="hub-link text-xs" onClick={() => unlock(b)} data-testid={`pb-unlock-btn-${b.id}`}>Unlock bill</button>
              )}</td>
            </tr>
          ))}
          {bills.length === 0 && <tr><td colSpan="8" className="opacity-50">No bills for this project.</td></tr>}
          </tbody></table>
      </div>
    </div>
  );
}
